const dateTimeFormatters = new Map<string, Intl.DateTimeFormat>();
const relativeTimeFormatters = new Map<string, Intl.RelativeTimeFormat>();
let defaultTimeZone: string | undefined;

const readDefaultTimeZone = (): string => {
  if (defaultTimeZone === undefined) {
    defaultTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // Share the live-zone probe across synchronous formatting calls only.
    queueMicrotask(() => { defaultTimeZone = undefined; });
  }
  return defaultTimeZone;
};

const formatterKey = (locale: string, options: object) =>
  JSON.stringify([locale, Object.entries(options).sort(([a], [b]) => a.localeCompare(b))]);

export const getDateTimeFormatter = (
  locale: string,
  options: Intl.DateTimeFormatOptions,
): Intl.DateTimeFormat => {
  const zonedOptions = options.timeZone === undefined
    ? { ...options, timeZone: readDefaultTimeZone() }
    : options;
  const key = formatterKey(locale, zonedOptions);
  let formatter = dateTimeFormatters.get(key);
  if (!formatter) {
    formatter = new Intl.DateTimeFormat(locale, zonedOptions);
    dateTimeFormatters.set(key, formatter);
  }
  return formatter;
};

export const getRelativeTimeFormatter = (
  locale: string,
  options: Intl.RelativeTimeFormatOptions,
): Intl.RelativeTimeFormat => {
  const key = formatterKey(locale, options);
  let formatter = relativeTimeFormatters.get(key);
  if (!formatter) {
    formatter = new Intl.RelativeTimeFormat(locale, options);
    relativeTimeFormatters.set(key, formatter);
  }
  return formatter;
};
